import { createStore, applyMiddleware } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly'
import createSagaMiddleware from 'redux-saga'

import rootReducer from '../reducers'
import rootSaga from '../sagas'
import initialState from './initialState'

export default function configureStore() {
  const sagaMiddleware = createSagaMiddleware({
    onError(error) {
      // TODO [future] log error to error services
      console.error('sagaMiddleware error', error)
    },
  })
  const composeEnhancers = composeWithDevTools({})

  return {
    ...createStore(
      rootReducer,
      initialState,
      composeEnhancers(applyMiddleware(sagaMiddleware)),
    ),
    runSaga: sagaMiddleware.run(rootSaga),
  }
}
